module.exports = "<p>\n  custom-logout works!\n</p>\n"